"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.concat.js");

var _classCallCheck2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/createClass"));

/**
 * Clase que representa los filtros de la consulta del listado de profesiones
 */
var FiltroProfesiones = /*#__PURE__*/function () {
  function FiltroProfesiones(profesion, agrupacion) {
    (0, _classCallCheck2.default)(this, FiltroProfesiones);
    this.profesion = profesion ? profesion : '';
    this.agrupacion = agrupacion ? agrupacion : null;
  }

  (0, _createClass2.default)(FiltroProfesiones, [{
    key: "toQuerystring",
    value: function toQuerystring() {
      var query = '&query=';
      if (this.profesion) query += "descrip~".concat(this.profesion).concat(this.agrupacion ? ',' : '');
      if (this.agrupacion) query += "agrup:".concat(this.agrupacion);
      return query;
    }
  }, {
    key: "clone",
    value: function clone(_ref) {
      var profesion = _ref.profesion,
          agrupacion = _ref.agrupacion;
      this.profesion = profesion;
      this.agrupacion = agrupacion;
    }
  }]);
  return FiltroProfesiones;
}();

exports.default = FiltroProfesiones;